import useSWR from "swr"
import { GoodsApi } from "../../../apis"
import type { MultiSupplierResult } from "../../../apis/goods"

// The buyer catalogue load, shared by the catalogue page and the product page
// (which falls back to it when opened from a link instead of from the grid,
// finding B11). Both use the same SWR key, so coming back from a product page
// to the same supplier is a cache hit.
//
// The supplier variant endpoint (GET /erp/order/variant, de-inventory-service
// routes/api/order/variant.ts) does take offset.page/limit, query, categoryId
// and a single brandId, but nothing for price, stock level, promotion or
// sort-by-price, and the facet counts (category, brand, stock) are taken from
// the whole list. Paging on the server would break those, so the list is still
// loaded per supplier in one request (B05 deferred).

export const catalogueKey = (supplierIds: string[]) =>
  supplierIds.length > 0 ? `/erp/order/variant/catalogue/${[...supplierIds].sort().join(",")}` : null

export type CatalogueProduct = Record<string, any>

export const flattenCatalogue = (result: MultiSupplierResult | undefined): CatalogueProduct[] =>
  (result?.suppliers || []).flatMap((s) =>
    (s.products || []).map((product: any) => ({
      ...product,
      supplierBusinessId: s.supplierId,
      supplierName: s.supplierName,
      isConsignment: false,
    })),
  )

export function useCatalogue(suppliers: any[]) {
  const ids = suppliers.map((s) => s.id)
  return useSWR(catalogueKey(ids), () => GoodsApi.variantMultiSupplier(suppliers), {
    shouldRetryOnError: true,
    errorRetryCount: 2,
    errorRetryInterval: 2000,
    revalidateOnFocus: false,
  })
}
